//a check to make sure the correct localhost is being used in development due to SPA Proxy hosting the web page on a different host than the backend
export function getApiUrl() {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
        return "https://localhost:5219"
    } else {
        return "";
    }
}